import { NAMES_ES } from "../../assets/appConstants/constants";
import CopyToClipboard from "../common/CopyToClipboard";
import { TableColumn } from "../../models/dataTable.model";
import { DataSite } from "../../models/site.model";
import './index.css'
import { Link } from "react-router-dom";


const TableSchema: TableColumn[] = [
  { key: 'code', name: NAMES_ES.code, width: '10%' },
  { key: 'name', name: NAMES_ES.name, width: '15%' },
  { key: 'created_date', name: NAMES_ES.created_date, width: '15%' },
  { key: 'address', name: NAMES_ES.address, width: '20%' },
  { key: 'description', name: NAMES_ES.description, width: '40%' },
]

const columnId: string = 'code'
const rowDetailPath = '/site/view/'

const rowDataPreprocesor = (rowData: any, project_code: string): any => {

  return {
    ...rowData,
    code_render: (
      <div className='site-table-column-id'>
        <span>
          <Link className="site-table-column-id__link" to={`/${project_code}${rowDetailPath}${rowData.code}`}>
            {rowData.code}
          </Link>
        </span>

        <div className='site-table-column-id__copyicon'>
          <CopyToClipboard targetText={rowData.code as string} />
        </div>
      </div>
    ),
  }
}

const handleDoubleClickRow = (project_code: string, site_code: string, navigate: any) => {
  navigate(`/${project_code}${rowDetailPath}${site_code}`)
}

export { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow }